import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function AdvancedMicrocontrollersIoTWorkshop() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        ECE Workshop on Advanced Microcontrollers for IoT Applications  
                                        (25th and 26th August 2025)
                                    </h2>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">
                                        <div className="row">

                                            {/* Day 1 Images */}
                                            <div className="col-md-6 mb-3 mb-lg-4">
                                                <a className="spotlight" href="https://admin.swec.ac.in/assetsswec/img/advanced-microcontrollers-iot-workshop/1000304579.jpg">
                                                    <img 
                                                        src="https://admin.swec.ac.in/assetsswec/img/advanced-microcontrollers-iot-workshop/1000304579.jpg" 
                                                        loading="lazy" 
                                                        alt="Day 1 - Advanced Microcontrollers for IoT Workshop" 
                                                        className="img-responsive center-block rounded-1" 
                                                    />
                                                </a>
                                            </div>

                                            <div className="col-md-6 mb-3 mb-lg-4">
                                                <a className="spotlight" href="https://admin.swec.ac.in/assetsswec/img/advanced-microcontrollers-iot-workshop/1000304582.jpg">
                                                    <img 
                                                        src="https://admin.swec.ac.in/assetsswec/img/advanced-microcontrollers-iot-workshop/1000304582.jpg" 
                                                        loading="lazy" 
                                                        alt="Day 1 - Advanced Microcontrollers for IoT Workshop" 
                                                        className="img-responsive center-block rounded-1" 
                                                    />
                                                </a>
                                            </div>

                                            {/* Day 2 Images */}
                                            <div className="col-md-6 mb-3 mb-lg-4">
                                                <a className="spotlight" href="https://admin.swec.ac.in/assetsswec/img/advanced-microcontrollers-iot-workshop/1000304585.jpg">
                                                    <img 
                                                        src="https://admin.swec.ac.in/assetsswec/img/advanced-microcontrollers-iot-workshop/1000304585.jpg" 
                                                        loading="lazy" 
                                                        alt="Day 2 - Advanced Microcontrollers for IoT Workshop" 
                                                        className="img-responsive center-block rounded-1" 
                                                    />
                                                </a>
                                            </div>

                                            <div className="col-md-6 mb-3 mb-lg-4">
                                                <a className="spotlight" href="https://admin.swec.ac.in/assetsswec/img/advanced-microcontrollers-iot-workshop/1000304730.jpg">
                                                    <img 
                                                        src="https://admin.swec.ac.in/assetsswec/img/advanced-microcontrollers-iot-workshop/1000304730.jpg" 
                                                        loading="lazy" 
                                                        alt="Day 2 - Advanced Microcontrollers for IoT Workshop" 
                                                        className="img-responsive center-block rounded-1" 
                                                    />
                                                </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default AdvancedMicrocontrollersIoTWorkshop;
